import React from 'react';
import { Button, Input, Modal } from 'semantic-ui-react';
import { normalizeSlugname } from 'src/components/helpers';

const NamePersonalization = (props) => {
  const { setInputs, inputs } = props;
  const [open, setOpen] = React.useState(false);
  const [preservePaidDot, setPreservePaidDot] = React.useState(false);

  const handleEventNameInput = (event) => {
    let value = normalizeSlugname(event?.target?.value)?.replace(/\./g, '') || '';
    let name = event.target.name;
    setInputs({
      ...inputs,
      [name]: preservePaidDot ? `${value}.` : value,
    });
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => {
        setPreservePaidDot((inputs.newEventSlugname || inputs.eventSlugname || '').includes('.'));
        setOpen(true);
      }}
      open={open}
      trigger={<Button size="mini">Personalizar nombre</Button>}
    >
      <Modal.Header>Personalizar nombre de evento</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Input
            style={{ margin: '0 10px 0 0' }}
            onChange={handleEventNameInput}
            name={'newEventSlugname'}
            value={
              inputs?.newEventSlugname?.replace?.(/_/g, ' ')?.replace?.(/\./g, '') ||
              inputs?.eventSlugname?.replace?.(/_/g, ' ')?.replace?.(/\./g, '')
            }
            placeholder="Nombre del evento"
            id="newEventSlugname"
          />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cancelar</Button>
        <Button
          content="Personalizar"
          primary
          onClick={() => {
            setOpen(false);
            const baseName = (inputs.newEventSlugname || inputs.eventSlugname || '').replace(
              /\./g,
              ''
            );
            setInputs({
              ...inputs,
              newEventSlugname: `${baseName}${preservePaidDot ? '.' : ''}`,
            });
          }}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default NamePersonalization;
